webpackJsonp([11],{

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_recaptcha__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__js_recaptcha__);


/***/ }),

/***/ 45:
/***/ (function(module, exports) {

/* global document, window, Promise */var SITE_KEY_ATTRIBUTE='data-recaptcha-sitekey';var ACTION_ATTRIBUTE='data-recaptcha-action';var READY_FLAG='recaptchaReady';var tokenInput=document.querySelector('['+SITE_KEY_ATTRIBUTE+']');var siteKey=tokenInput!==null?tokenInput.getAttribute(SITE_KEY_ATTRIBUTE):'';// Resolves on 'error' as well, so that a blocked or unreachable api.js
// does not keep the form from being submitted.
function loadApiScript(){return new Promise(function(resolve){var script=document.createElement('script');script.async=true;script.defer=true;script.src='https://www.google.com/recaptcha/api.js?render='+siteKey;script.addEventListener('load',resolve);script.addEventListener('error',resolve);window.document.body.appendChild(script);});}function requestToken(apiScriptLoaded){return apiScriptLoaded.then(function(){return new Promise(function(resolve){var _window=window,grecaptcha=_window.grecaptcha;if(grecaptcha===undefined){resolve();return;}grecaptcha.ready(function(){grecaptcha.execute(siteKey,{action:tokenInput.getAttribute(ACTION_ATTRIBUTE)}).then(function(token){tokenInput.value=token;resolve();})// On any reCAPTCHA failure the form is sent with an empty token
// and the server side decides what to do with it.
.catch(resolve);});});});}// reCAPTCHA tokens are valid for two minutes only, so the token is requested on submit
// instead of on page load - filling in the registration form takes a while.
function handleSubmit(event,apiScriptLoaded){var form=event.target;if(event.defaultPrevented||form.dataset[READY_FLAG]==='1'){return;}event.preventDefault();requestToken(apiScriptLoaded).then(function(){var submitButton=form.querySelector('input[type="submit"]');form.dataset[READY_FLAG]='1';// Clicking the button instead of calling form.submit() keeps both
// the netteForms validation and the name of the submit button in the request.
if(submitButton!==null){submitButton.click();}else{form.submit();}});}if(tokenInput!==null&&siteKey!==''&&tokenInput.form!==null){var apiScriptLoaded=loadApiScript();tokenInput.form.addEventListener('submit',function(event){return handleSubmit(event,apiScriptLoaded);});}

/***/ })

},[44]);


// WEBPACK FOOTER //
// js/registration.20d0a40e.js